import request from '@/utils/request'

// Which service answers every venue lookup in the app.
// Backend: /api/v2/admin/places-provider (request baseURL already includes /api/v2).

export interface PlacesProviderState {
  // What is answering right now.
  active: string
  // What the configs table says, or null when the row has never been written.
  configured: string | null
  // What the service falls back to when there is no usable config row.
  fallback: string
  supported: string[]
}

export const getPlacesProvider = () =>
  request({ url: '/admin/places-provider', method: 'get' })

export const setPlacesProvider = (provider: string) =>
  request({ url: '/admin/places-provider', method: 'put', data: { provider } })
